"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Textarea = void 0;
var textArea_1 = require("./textArea");
Object.defineProperty(exports, "Textarea", { enumerable: true, get: function () { return __importDefault(textArea_1).default; } });
//# sourceMappingURL=index.js.map